import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { closePopup } from "../redux/actions/modal";
import CrossCloseButton from "./parts/CrossCloseButton";

export default function () {
  const dispatch = useDispatch();

  const approveHandler = (e) => {
    e.preventDefault();
    return dispatch(closePopup());
  };

  return (
    <div className="modal modal_w593 modal-wallet">
      <div className="modal-wallet__close-window">
        <CrossCloseButton />
      </div>
      <div className="buy_popup_main">
        <div>
          <h4>ASKO on ETH</h4>
          <button
            className="uniswap_btn"
            onClick={() => {
              window.open(
                "https://app.uniswap.org/#/swap?outputCurrency=0xeeee2a622330e6d2036691e983dee87330588603"
              );
            }}
          >
            <img src="../assets/images/uniswap.png" />
            Uniswap
          </button>
        </div>
        <div>
          <h4>ASKO on BSC</h4>
          <button className="">Coming Soon</button>
        </div>
      </div>
    </div>
  );
}
